<template>
    <div class="app-modal-dialog">
        <div class="app-modal-dialog__content">
            <div class="app-modal-dialog__header">
                <div class="app-modal-dialog__titles">
                    <div class="app-tab-navigation">
                        <div class="app-tab-navigation__breadcrumbs">
                            <div class="app-tab-navigation__breadcrumb is--active">File Upload</div>
                        </div>
                    </div>
                    <h4 class="app-modal-dialog__title">AI Generation: {{ this.publication.name }}</h4>
                    <p class="app-modal-dialog__section-instructions">Optionally, upload related content files and course syllabus. This will assist the AI with course outline generation.</p>
                </div>
            </div>
            <!-- publication builder component -->
            <div class="app-modal-dialog__body">
                <asset-manager ref="manager"
                    :source="assetSource" 
                    :files="assetFiles"
                    :show-assignment-filters="false"
                    :select-mode="false"
                    :auto-load="true"
                    :valid-extensions="validExtensions"
                    :valid-mime-types="validMimeTypes"
                    :max-file-size="maxFileSize">
                </asset-manager>
            </div>

            <form class="app-modal-dialog__footer" @submit.prevent="submit()" autocomplete="off">
                <fieldset class="checkbox">
                    <label class="checkbox__label">
                    <input type="checkbox" class="checkbox__input" name="dismiss-ai" id="dismiss-ai"
                        v-model="aiDismissFlag">
                        Generate the content only using the uploaded document(s).</label>
                </fieldset>
                <a class="element-button--secondary element-button" 
                    :href="`/projects/${project.id}/publications`">
                    Close
                </a>
                <app-button :theme="aiExistingSession ? 'ai-ghost':'ai-primary'" type="submit" class="" :disabled="disabled">
                    <svg class="element-icon--ai element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-ai"></use></svg>
                    {{ disabled ? 'Processing...' : 'Start New Session' }}
                </app-button>

                <app-button :theme="aiExistingSession ? 'ai-primary':'ai-ghost'" v-if="aiExistingSession" @click.prevent="relayPage()" :disabled="disabled"
                    aria-label="Previous">
                    <svg class="element-icon--ai element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-ai"></use></svg>
                    Continue with Existing Session</app-button>
            </form>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import api from '../api/ai'

export default {
    props: {
        project: {
            type: Object
        },
        item: {
            type: Object
        },
        assetFiles: {
            type: Array
        },
        assetSource: {
            type: String,
        },
        validExtensions: {
            type: Object,
            default: () => { "document" }
        },
        validMimeTypes: {
            type: Object,
            default: () => ({})
        },
        maxFileSize: {
            type: Number,
            default: (50 * 1024 * 1024) // 50MB
        }
    },
    data() {
        return {
            publication: this.item,
            aiExistingSession: this.item.ai_preferences['sessionId'] ? this.item.ai_preferences['sessionId'] : '',
            disabled: false,
            aiDismissFlag: this.item.ai_preferences['dismissAi'] ? true : false
        }
    },
    methods: {
        setDisabled(value = true) {
            this.disabled = value
        },
        relayPage() {
            this.setDisabled(true)
            window.location.href = '/publications/' + this.publication.id + '/ai-relay';
        },
        async submit() {
            console.info('Saving page data...')
            this.setDisabled(true)
            
            var params = { dismissAi: this.aiDismissFlag };

            // api call to prepare
            const result = await api.initialize(this.publication.id, params)

            console.log(result)
            if (result.errors) {
                // catch errors
                this.setDisabled(false)
                alert(result.errors)
                // TODO: display errors
            } else {
                // redirect
                this.relayPage()
            }
        }
    }
}
</script>